import { ofType, Epic, StateObservable } from 'redux-observable';
import { IshState } from 'src/js/services/IshState';
import { mergeMap, Observable } from 'rxjs';
import { resetFieldsState, setFieldsToState, SUBMIT_EDIT_CONTACT } from '../actions/Actions';
import { Contact } from '@api';
import { addContactToSummary } from '../../summary/actions/Actions';
import { changePhase, updateContactAddProcess } from '../../../actions/Actions';
import { Phase } from '../../../reducers/State';

export const SubmitEditContact: Epic<any, IshState> = (action$: Observable<any>, store: StateObservable<IshState>): Observable<any> => {
  return action$.pipe(
    ofType(SUBMIT_EDIT_CONTACT),
    mergeMap(action => {
      const state = store.value;
      const contact: Contact = action.payload;
      const result = [];

      result.push(resetFieldsState());
      result.push(addContactToSummary(contact));

      const unfilled = state.checkout.fields.unfilled.filter(fields => fields.contactId !== action.payload.id);

      if (unfilled.length) {
        const nextFileds = unfilled[0];
        result.push(changePhase(Phase.Summary));
        result.push(setFieldsToState(nextFileds));
        result.push(updateContactAddProcess(state.checkout.contacts.entities.contact[nextFileds.contactId], Phase.Summary, null));
        result.push(changePhase(Phase.ComplementEditContact));
      }

      return result;
    })
  );
};

